import { Chess } from 'chess.js';
import type { Key } from 'chessground/types';
import type { InContextLine } from '../inContextMapping';

/**
 * Étape d'animation pour `InContextIntro` (MVP2.6 Gap 2).
 *
 * Fichier séparé du composant pour respecter
 * `react-refresh/only-export-components`.
 */
export interface AnimationStep {
  fen: string;
  lastMove: [Key, Key] | undefined;
  moveNumber: number;
  san: string | null;
}

/**
 * Construit la liste des FEN intermédiaires à animer pour une ligne
 * d'ouverture donnée. Retourne `[initial, après-coup-1, ..., après-coup-N]`.
 *
 * Si un coup SAN est illégal (mapping cassé), `chess.move()` throw — c'est
 * le comportement attendu : on ne livre pas de mainline cassée en prod,
 * le test `inContextMapping.test.ts` couvre la légalité de chaque ligne.
 */
export function buildAnimationSteps(line: InContextLine): AnimationStep[] {
  const chess = new Chess();
  const steps: AnimationStep[] = [
    { fen: chess.fen(), lastMove: undefined, moveNumber: 0, san: null },
  ];
  for (let i = 0; i < line.moves.length; i++) {
    const san = line.moves[i];
    if (!san) continue;
    const res = chess.move(san);
    if (!res) continue;
    steps.push({
      fen: chess.fen(),
      lastMove: [res.from as Key, res.to as Key],
      moveNumber: i + 1,
      san,
    });
  }
  return steps;
}
